import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import EcoButton from 'eco-design/base/eco-button';
import gtm from '@/utils/gtm';

const Choose = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail');

    const handleClick = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'jump_button',
            position: 'Inpage',
            button_name: t(`learn_more`),
            url: 'https://www.ecoflow.com/us/delta-pro-ultra-x',
            __btn_id1: `Choose .learn-more`,
            __btn_id2: 'https://www.ecoflow.com/us/delta-pro-ultra-x',
            __btn_type: 'href',
        });
    };

    return (
        <div className={`${styles.choose} Choose GtmModuleData-section`} data-section-id={styles.choose} data-section-title={t(`choose_title`)}>
            <div className="text-container">
                <h2>{t(`choose_title`)}</h2>
            </div>
            <div className="content">
                <div className="card">
                    <EcoImg
                        pc={'https://websiteoss.ecoflow.com/upload/image/1773199828033/8-pc-1.jpg'}
                        pad='https://websiteoss.ecoflow.com/upload/image/1773199827194/8-m-1.jpg'
                        alt={t('choose_dpux1')}
                        isOpenLazy={true}
                        className="banner"
                    />

                    <div className="text-wrapper">
                        <div className="title">{t('choose_ocean_title')}</div>
                        <p>• {t(`choose_ocean1`)}</p>
                        <p>• {t(`choose_ocean2`)}</p>
                        <p>• {t(`choose_ocean3`)}</p>
                        <div className="curent-view">{t(`curent_view`)}</div>
                    </div>
                </div>
                <div className="card">
                    <EcoImg
                        pc={'https://websiteoss.ecoflow.com/upload/image/1773199827791/8-pc-2.jpg'}
                        pad='https://websiteoss.ecoflow.com/upload/image/1773199827689/8-m-2.jpg'
                        alt={t('choose_ocean1')}
                        isOpenLazy={true}
                        className="banner"
                    />
                    <div className="text-wrapper">
                        <div className="title">{t('choose_dpux_title')}</div>
                        <p>• {t(`choose_dpux1`)}</p>
                        <p>• {t(`choose_dpux2`)}</p>
                        <p>• {t(`choose_dpux3`)}</p>
                        <a
                            href="https://www.ecoflow.com/us/delta-pro-ultra-x"
                            className="learn-more GtmModuleData-btn-href"
                            target="_blank"
                            onClick={handleClick}
                        >
                            <EcoButton>{t(`learn_more`)}</EcoButton>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Choose;
